export const accountTabsArray = [
  { index: 0, name: 'Coordonnées', onlyAdmin: false },
  { index: 1, name: 'Mot de passe', onlyAdmin: false },
  { index: 2, name: 'Paramètres Pige', onlyAdmin: false },
  { index: 3, name: 'Equipe', onlyAdmin: false },
  { index: 4, name: 'Abonnement', onlyAdmin: true },
  { index: 5, name: 'Statistiques', onlyAdmin: true },
];
